
import { Options, Vue } from 'vue-class-component'
import { usePriceStore } from '@/stores/price'
import { PriceService } from '@/bll/service/PriceService'
import Logger from '@/util/logger'

/**
 * @author Ahto Jalak
 * @since 06.02.2023
 */
@Options({
    components: {},
    props: {
        id: String
    },
    emits: [],
})
export default class PriceDetails extends Vue {
    private logger = new Logger(PriceDetails.name)
    id!: string
    wishesStore = usePriceStore()
    wishService = new PriceService()

    async mounted (): Promise<void> {
        this.logger.info('mounted')
        // this.wishesStore.$state.price =
        //     await this.wishService.get(this.id)
    }
}

